import { useCallback } from 'react';

import { PERFORM_OFFER_ACTION_MUTATION } from '@applicant-flow/graphql';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';

export const useOfferActions = ({
  refetchQueries = [],
}: {
  refetchQueries?: string[];
}) => {
  const [performOfferAction, { loading }] = useMutation(
    PERFORM_OFFER_ACTION_MUTATION,
    {
      errorPolicy: 'all',
      refetchQueries,
      onCompleted(data) {
        if (!data || !data.performOfferAction) return;
        createMessage('success', 'Offer successfully retracted!');
      },
      onError: () => {
        createMessage(
          'error',
          'Failed to update Offer state. Please try again or contact your hiring partner.'
        );
      },
    }
  );

  const retractOffer = useCallback(
    (offerId?: string | null) => {
      if (!offerId) return;

      performOfferAction({
        variables: {
          offerId: offerId,
          input: {
            action: 'retract',
          },
        },
      });
    },
    [performOfferAction]
  );

  return { loading, retractOffer };
};
